import React, { useMemo, useState } from "react";

const MENU = {
  rice: ["Jeera Rice","Curd Rice","Tomato Rice","Lemon Rice","Tamarind Rice","Sambar Rice","Bisi Bele Bath","Pongal","Veg Pulav / Matar Rice / Peas Pulao","Fried Rice","Veg Biryani","Mushroom Biryani","Paneer Biryani","Soya Chunk Biryani"],
  curry: ["Veg Kurma","Paneer Butter Masala","Mushroom Masala","Channa Masala","Rajma","Dal / Dal Makhani / Tomato Pappu / Moong Pappu","Bottle Gourd Curry","Ennai Kathirikai","Aloo Gobi","Bhindi Masala","Black Chana","Mix Veg","Eggplant Curry","Poriyal (Cabbage / Beetroot / Mixed)"],
  starter: ["Gobi 65 (Semi-Gravy)","Gobi Manchurian","Pakoda / Mix Pakora / Onion Pakora","Bajji (Chilli / Potato / Onion)","Bonda (Mysore / Aloo)","Vada (Plain / Masala / Dal / Sambar / Dahi)","Chilli Idli / Podi Idli"],
  sweet: ["Gulab Jamun","Rava Kesari - Regular","Rava Kesari - Mango","Rava Kesari - Pineapple"],
  included: ["Sambar","Rasam","Curd","Papad","White Rice","Poori (2/person)","Chapathi (2/person)","Pickle"]
};

const emptyCustom = () => ({ item:"", quantity:"", size:"", notes:"" });

function cateringMonth(dateString) {
  if (!dateString) return "";
  const [y,m,d] = dateString.split("-").map(Number);
  return new Intl.DateTimeFormat("en-CA", { month:"long", year:"numeric" })
    .format(new Date(y, m - 1, d));
}

export default function Catering() {
  const [orderType, setOrderType] = useState("package");
  const [form, setForm] = useState({
    name:"", phone:"", email:"", eventDate:"", eventTime:"", guests:"",
    fulfillment:"Pickup", address:"", eventType:"",
    rice:"", curry:[], starter:"", sweets:[], extras:[],
    customItems:[emptyCustom()], notes:"", allergies:""
  });
  const [status, setStatus] = useState({loading:false,message:"",ok:false});

  const set = (key,value) => setForm(f=>({...f,[key]:value}));
  const toggle = (key,value,max) => {
    const values=form[key];
    if(values.includes(value)) set(key,values.filter(x=>x!==value));
    else if(!max || values.length<max) set(key,[...values,value]);
  };
  const updateCustom=(i,key,value)=>{
    const rows=[...form.customItems];
    rows[i]={...rows[i],[key]:value};
    set("customItems",rows);
  };
  const validCustom=useMemo(
    ()=>form.customItems.filter(x=>x.item.trim()||x.quantity.trim()||x.size.trim()||x.notes.trim()),
    [form.customItems]
  );

  async function submit(e){
    e.preventDefault();
    setStatus({loading:true,message:"",ok:false});
    const payload={...form,orderType,cateringMonth:cateringMonth(form.eventDate),customItems:validCustom};
    const url=process.env.REACT_APP_CATERING_SCRIPT_URL;
    if(!url){setStatus({loading:false,ok:false,message:"Catering service is not configured. Please contact Carnatic Cafe."});return;}
    try{
      const res=await fetch(url,{method:"POST",headers:{"Content-Type":"text/plain;charset=utf-8"},body:JSON.stringify(payload),redirect:"follow"});
      const raw=await res.text();
      let data; try{data=JSON.parse(raw);}catch(_){throw new Error("Unable to read the catering service response.");}
      if(!data.ok){
        if(data.code==="DUPLICATE_CATERING_REQUEST") throw new Error(data.existingRequestId?`A catering request with the same contact, date and time already exists (${data.existingRequestId}).`:"A catering request with the same contact, date and time already exists.");
        throw new Error(data.error||"Unable to submit request.");
      }
      setStatus({loading:false,ok:true,message:`Thank you! Your catering request ${data.requestId} has been received. We will contact you to confirm availability and final pricing.`});
    }catch(err){setStatus({loading:false,ok:false,message:err.message||"Unable to submit request. Please try again."});}
  }

  return (
    <main className="catering-page">
      <style>{`
        .catering-page{background:#FFF9F0;min-height:100vh;color:#12262A}
        .cat-wrap{max-width:1100px;margin:0 auto;padding-left:24px;padding-right:24px}
        .cat-hero{text-align:center;padding:56px 0 36px;background:#F6EAD0}
        .cat-kicker{letter-spacing:.18em;font-weight:900;color:#C69A35}
        .cat-hero h1{font-family:Georgia,serif;font-size:clamp(34px,5vw,54px);font-weight:900;margin:8px 0}
        .price-pill{display:inline-block;margin:16px 0;padding:9px 18px;border:1px solid #C69A35;border-radius:999px;font-weight:800}
        .price-pill span{font-weight:500}
        .cat-primary,.cat-secondary{display:inline-block;border:0;border-radius:999px;padding:12px 20px;font-weight:800;cursor:pointer;text-decoration:none}
        .cat-primary{background:#C86B1E;color:white}.cat-secondary{background:white;color:#12262A;border:1px solid #C69A35}
        .cat-intro{padding-top:30px;padding-bottom:16px}.order-type-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:14px}
        .order-card{padding:18px;text-align:left;border:1px solid #E8DDC8;border-radius:16px;background:white;cursor:pointer}
        .order-card.active{border:2px solid #C69A35;background:#F6EAD0}.order-card strong,.order-card span{display:block}.order-card span{margin-top:5px;color:#3C4A4E}
        .cat-form{padding-top:12px;padding-bottom:50px}.form-section{background:white;border:1px solid #E8DDC8;border-radius:18px;padding:22px;margin:0 0 22px}
        .section-heading{display:flex;gap:12px;align-items:flex-start}.section-heading>span{background:#C69A35;color:white;border-radius:999px;padding:5px 9px;font-weight:800}
        .section-heading h2{margin:0;font-family:Georgia,serif;font-size:27px}.section-heading p{margin:4px 0 16px;color:#3C4A4E}
        .form-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:16px}.form-grid label{font-weight:700}.form-grid input,.form-grid select,.form-grid textarea,.custom-row input{width:100%;margin-top:6px;padding:11px 12px;border:1px solid #E8DDC8;border-radius:12px;background:white}
        .wide{grid-column:1/-1}.sheet-note{color:#3C4A4E}.menu-block{margin-top:25px}.menu-title{display:flex;align-items:baseline;gap:10px;flex-wrap:wrap}.menu-title h3{font-family:Georgia,serif;font-size:22px}.menu-title span{color:#3C4A4E}
        .choice-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:10px}.choice{padding:12px;border:1px solid #E8DDC8;border-radius:12px;background:white;font-weight:650;cursor:pointer}.choice.selected{border-color:#C69A35;background:#F6EAD0}.choice input{margin-right:8px}
        .custom-table{display:grid;gap:10px}.custom-row{display:grid;grid-template-columns:1.3fr 1fr 1fr 1.3fr auto;gap:8px;align-items:center;background:#F6EAD0;padding:10px;border-radius:14px}.remove{border:0;background:transparent;font-size:24px;cursor:pointer}
        .submit-box{display:flex;justify-content:space-between;align-items:center;gap:16px;flex-wrap:wrap;background:white;border:1px solid #E8DDC8;border-radius:18px;padding:22px}.submit-box strong,.submit-box small{display:block}.form-message{margin-top:12px;padding:14px;border-radius:12px}.success{background:#ECFDF5;color:#065F46}.error{background:#FEF2F2;color:#991B1B}
        @media(max-width:760px){.order-type-grid,.form-grid,.choice-grid{grid-template-columns:1fr}.custom-row{grid-template-columns:1fr}.cat-wrap{padding-left:16px;padding-right:16px}}
      `}</style>
      <section className="cat-hero">
        <div className="cat-wrap">
          <h1>Pure Veg. Authentic Flavours. Perfectly Catered</h1>
          <p>Build a complete catering package or send us a custom order for individual dishes, trays and quantities.</p>
          <div className="price-pill">$19–$24 / person <span>for catering packages*</span></div>
          <a className="cat-primary" href="#request">Build Your Catering Request</a>
        </div>
      </section>

      <section className="cat-wrap cat-intro">
        <h2>Choose how you'd like to order</h2>
        <div className="order-type-grid">
          <button type="button" className={`order-card ${orderType==="package"?"active":""}`} onClick={()=>setOrderType("package")}>
            <strong>Catering Package</strong><span>Choose rice, curries, starter, sweets and accompaniments.</span>
          </button>
          <button type="button" className={`order-card ${orderType==="custom"?"active":""}`} onClick={()=>setOrderType("custom")}>
            <strong>Custom Catering Order</strong><span>Request individual items, trays, quantities and sizes.</span>
          </button>
        </div>
      </section>

      <form id="request" className="cat-wrap cat-form" onSubmit={submit}>
        <section className="form-section">
          <div className="section-heading"><span>01</span><div><h2>Your Details</h2><p>Tell us who to contact about the order.</p></div></div>
          <div className="form-grid">
            <label>Name*<input required value={form.name} onChange={e=>set("name",e.target.value)}/></label>
            <label>Phone*<input required type="tel" value={form.phone} onChange={e=>set("phone",e.target.value)}/></label>
            <label>Email*<input required type="email" value={form.email} onChange={e=>set("email",e.target.value)}/></label>
            <label>Event Type<input placeholder="Birthday, office lunch, puja..." value={form.eventType} onChange={e=>set("eventType",e.target.value)}/></label>
          </div>
        </section>

        <section className="form-section">
          <div className="section-heading"><span>02</span><div><h2>Date & Fulfillment</h2><p>When and how do you need your catering?</p></div></div>
          <div className="form-grid">
            <label>Catering Date*<input required type="date" value={form.eventDate} onChange={e=>set("eventDate",e.target.value)}/></label>
            <label>Required Time*<input required type="time" value={form.eventTime} onChange={e=>set("eventTime",e.target.value)}/></label>
            <label>Number of Guests<input min="1" type="number" value={form.guests} onChange={e=>set("guests",e.target.value)}/></label>
            <label>Pickup / Delivery*
              <select value={form.fulfillment} onChange={e=>set("fulfillment",e.target.value)}>
                <option>Pickup</option><option>Delivery</option>
              </select>
            </label>
            {form.fulfillment==="Delivery"&&<label className="wide">Delivery Address*<input required value={form.address} onChange={e=>set("address",e.target.value)}/></label>}
          </div>
          {form.eventDate && <p className="sheet-note">This request will be filed under the Google Sheet tab: <strong>{cateringMonth(form.eventDate)}</strong></p>}
        </section>

        {orderType==="package"?(
          <section className="form-section">
            <div className="section-heading"><span>03</span><div><h2>Build Your Menu</h2><p>Customizable catering package. Final price depends on your selections.</p></div></div>
            <MenuRadio title="Rice" subtitle="Choose 1" items={MENU.rice} value={form.rice} onChange={v=>set("rice",v)}/>
            <MenuChecks title="Curry" subtitle={`Choose 2 • ${form.curry.length}/2 selected`} items={MENU.curry} values={form.curry} onToggle={v=>toggle("curry",v,2)}/>
            <MenuRadio title="Fry / Dry / Starter" subtitle="Choose 1" items={MENU.starter} value={form.starter} onChange={v=>set("starter",v)}/>
            <MenuChecks title="Sweet" subtitle="Choose any" items={MENU.sweet} values={form.sweets} onToggle={v=>toggle("sweets",v)}/>
            <MenuChecks title="Accompaniments" subtitle="Select what you need" items={MENU.included} values={form.extras} onToggle={v=>toggle("extras",v)}/>
          </section>
        ):(
          <section className="form-section">
            <div className="section-heading"><span>03</span><div><h2>Custom Catering Order</h2><p>Perfect for orders such as vada, chutneys, sambar trays or individual dishes.</p></div></div>
            <div className="custom-table">
              {form.customItems.map((row,i)=>(
                <div className="custom-row" key={i}>
                  <input aria-label="Item" placeholder="Item — e.g. Vada" value={row.item} onChange={e=>updateCustom(i,"item",e.target.value)}/>
                  <input aria-label="Quantity" placeholder="Qty — e.g. 54 pieces" value={row.quantity} onChange={e=>updateCustom(i,"quantity",e.target.value)}/>
                  <input aria-label="Size" placeholder="Size — e.g. 24 oz" value={row.size} onChange={e=>updateCustom(i,"size",e.target.value)}/>
                  <input aria-label="Notes" placeholder="Notes" value={row.notes} onChange={e=>updateCustom(i,"notes",e.target.value)}/>
                  {form.customItems.length>1&&<button type="button" className="remove" onClick={()=>set("customItems",form.customItems.filter((_,x)=>x!==i))}>×</button>}
                </div>
              ))}
            </div>
            <button type="button" className="cat-secondary" onClick={()=>set("customItems",[...form.customItems,emptyCustom()])}>+ Add Another Item</button>
          </section>
        )}

        <section className="form-section">
          <div className="section-heading"><span>04</span><div><h2>Anything Else?</h2><p>Share allergies, dietary requirements or special instructions.</p></div></div>
          <div className="form-grid">
            <label className="wide">Allergies / Dietary Notes<textarea rows="3" value={form.allergies} onChange={e=>set("allergies",e.target.value)}/></label>
            <label className="wide">Special Instructions<textarea rows="4" placeholder="Packaging, spice level, serving notes, other requests..." value={form.notes} onChange={e=>set("notes",e.target.value)}/></label>
          </div>
        </section>

        <div className="submit-box">
          <div><strong>{orderType==="package"?"$19–$24 per person":"Custom order — quote after review"}</strong><small>*Final pricing and availability are confirmed by Carnatic Cafe.</small></div>
          <button className="cat-primary" disabled={status.loading}>{status.loading?"Sending...":"Submit Catering Request"}</button>
        </div>
        {status.message&&<div className={`form-message ${status.ok?"success":"error"}`}>{status.message}</div>}
      </form>
    </main>
  );
}

function MenuRadio({title,subtitle,items,value,onChange}){
  return <div className="menu-block"><div className="menu-title"><h3>{title}</h3><span>{subtitle}</span></div><div className="choice-grid">
    {items.map(x=><label className={`choice ${value===x?"selected":""}`} key={x}><input type="radio" name={title} checked={value===x} onChange={()=>onChange(x)}/>{x}</label>)}
  </div></div>;
}
function MenuChecks({title,subtitle,items,values,onToggle}){
  return <div className="menu-block"><div className="menu-title"><h3>{title}</h3><span>{subtitle}</span></div><div className="choice-grid">
    {items.map(x=><label className={`choice ${values.includes(x)?"selected":""}`} key={x}><input type="checkbox" checked={values.includes(x)} onChange={()=>onToggle(x)}/>{x}</label>)}
  </div></div>;
}